import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol
} from "../../../components";
import Highlight from "react-highlight";
import { history } from "../../../redux/store/configureStore";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { appConfig } from "../../../config";
import {
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
  Row,
  Col,
  Checkbox,
} from "react-bootstrap";
import { createHashHistory } from "history";
import { Notification } from "../../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import auth from "../../../services/auth";
import Switch from "react-switch";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withRouter } from "react-router-dom";
import { createUser, userDetail } from "../../../redux/actions/accessAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgType: "",
      alertMessage: "",
      show: false,
      path: ["Home", "Edit Sub Admin"],
      links: ["home","/subadmin/add"],
      disabled: false,
      userName: "",
      email: "",
      firstName: "",
      lastName: "",
      status: "Active",
      password: "",
      sites: [],
      checked_site: [],
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let status = true;

    if(this.state.userName == ''){
      this.setState({userNameError: "red"});
      status = false;
    }

    if(this.state.firstName == ''){
      this.setState({firstNameError: "red"});
      status = false;
    }

    if(this.state.lastName == ''){
      this.setState({lastNameError: "red"});
      status = false;
    }

    if(this.state.email == ''){
      this.setState({emailError: "red"});
      status = false;
    }

    return status;
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let valid = this.validate();

    if(valid){
      const postData = {
        subadminID : this.state.userID,
        sites: this.state.checked_site,
      }

      this.props.createUser(postData, 'multisite-subadmin/save', 'POST');
    }
  }

  componentWillMount(){
    let user_id = this.props.match.params.user_id
      ? this.props.match.params.user_id
      : "";

    if(user_id){
      this.props.userDetail(`multisite-subadmin/detail/${user_id}`);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.detail != nextProps.detail){
      if(nextProps.detail){
        this.setState(nextProps.detail.data);
      }
    }

    if(this.props.status != nextProps.status){
      if(nextProps.status){
        this.handleShow();
        this.props.clearAlert();
        if(nextProps.status.data.response == 'error'){
          this.props.renderAlert("danger", nextProps.status.data.message);
        }else{
          this.props.renderAlert("success", nextProps.status.data.message);
        }
        let user_id = this.props.match.params.user_id
          ? this.props.match.params.user_id
          : "";

        if(user_id){
          this.props.userDetail(`multisite-subadmin/detail/${user_id}`);
        }
        window.scrollTo(0, 0);
      }
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        this.handleShow();
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleChange = (e) => {
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSite = (e) => {
    const checked_site = this.state.checked_site;

    let index;

    if (e.target.checked) {
      this.setState({ checked_siteError: "" });
      checked_site.push(e.target.value);
    } else {
      index = checked_site.indexOf(e.target.value);
      checked_site.splice(index, 1);
    }
    this.setState({ checked_site: checked_site });
  }
  
  render() {
    const headerTitle = "Edit Sub Admin";
    return (
      <div className="col-xs-12 site-list">
        
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Edit Sub Admin</header>
          <div className="panel-body">
            <div className="row">
              <div className="col-xs-12">
                {this.state.show &&
                  this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>Message:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
              </div>
            </div>
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit} autoComplete="off">
                  <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicUserNameText">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> User Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="userName"
                        value={this.state.userName}
                        placeholder="Enter User Name"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.userNameError }}
                        autoComplete="off"
                        disabled={true}
                      />
                    </FormGroup>
                    
                    <FormGroup controlId="formBasicFirstNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> First Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.firstName}
                        placeholder="Enter First Name"
                        onChange={this.handleChange}
                        name="firstName"
                        style={{ borderColor: this.state.firstNameError }}
                        autoComplete="off"
                        disabled={true}
                      />
                    </FormGroup>
                    
                    
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Email
                    </ControlLabel>
                    <FormGroup
                      controlId="formBasicEmailText"
                    >
                      <FormControl
                        type="email"
                        value={this.state.email}
                        placeholder="Enter email"
                        onChange={this.handleChange}
                        name="email"
                        style={{ borderColor: this.state.emailError }}
                        autoComplete="off"
                        disabled={true}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLastNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Last Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.lastName}
                        placeholder="Enter Last Name"
                        onChange={this.handleChange}
                        name="lastName"
                        style={{ borderColor: this.state.lastNameError }}
                        autoComplete="off"
                        disabled={true}
                      />
                    </FormGroup>
                  </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <table className="table table-hover" responsive="true">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Site Name</th>
                            <th>Site Domain</th>
                          </tr>
                        </thead>
                        <tbody>
                            {(!isEmpty(this.state.sites)) ?
                              this.state.sites.map((site, index) => 
                                <tr key={`siteLis-${index}`}>
                                  <td>
                                    {this.state.checked_site.indexOf(site.siteID) > -1 ? (
                                      <Checkbox defaultChecked={true} value={site.siteID} onChange={this.handleSite}></Checkbox>
                                    ) : (
                                      <Checkbox defaultChecked={false} value={site.siteID} onChange={this.handleSite}></Checkbox>
                                    )}
                                  </td>
                                  <td>{site.siteName}</td>
                                  <td>{site.siteDomain}</td>
                                </tr>
                              )
                            :
                            <tr>
                              <td colSpan={3}>Sites Not Available.</td>
                            </tr>
                            }
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  <Row className="BtnRow">
                    <Col md={12} xs={12} className="pull-right">
                      <Button
                        bsStyle="info"
                        type="submit"
                        id="saveButton"
                        disabled={this.state.disabled}
                      >
                        Save
                      </Button>
                      <Button
                        bsStyle="default"
                        onClick={() => history.push(`/subadmin/list`)}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.user.error,
	status: state.user.status,
	alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  detail: state.user.detail,
});


export default withRouter(connect(mapStateToProps, { createUser, userDetail, renderAlert, clearAlert })(Edit));



// WEBPACK FOOTER //
// ./src/app/views/Users/SubAdmin/Edit.js